/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {
  NgModule,
  Directive,
  HostBinding,
  Output,
  Input,
  EventEmitter
} from '@angular/core';

export type LayoutDirection = 'ltr' | 'rtl';
/**
 * Directive to listen for changes of direction of part of the DOM.
 * 
 * Applications should use this directive instead of the native attribute so that Material
 * components can listen on changes of direction.
 */
export class Dir {
/**
 * Layout direction of the element.
 */
_dir: LayoutDirection = 'ltr';
/**
 * Event emitted when the direction changes.
 */
dirChange = new EventEmitter<void>();
/**
 * \@docs-private
 * @return {?}
 */
get dir(): LayoutDirection {
    return this._dir;
  }
/**
 * @param {?} v
 * @return {?}
 */
set dir(v: LayoutDirection) {
    let /** @type {?} */ old = this._dir;
    this._dir = v;
    if (old != this._dir) {
      this.dirChange.emit();
    }
  }
/**
 * Current layout direction of the element.
 * @return {?}
 */
get value(): LayoutDirection { return this.dir; }
/**
 * @param {?} v
 * @return {?}
 */
set value(v: LayoutDirection) { this.dir = v; }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[dir]',
  // TODO(hansl): maybe `$implicit` isn't the best option here, but for now that's the best we got.
  exportAs: '$implicit'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'_dir': [{ type: Input, args: ['dir', ] },],
'dirChange': [{ type: Output },],
'dir': [{ type: HostBinding, args: ['attr.dir', ] },],
};
}

function Dir_tsickle_Closure_declarations() {
/** @type {?} */
Dir.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Dir.ctorParameters;
/** @type {?} */
Dir.propDecorators;
/**
 * Layout direction of the element.
 * @type {?}
 */
Dir.prototype._dir;
/**
 * Event emitted when the direction changes.
 * @type {?}
 */
Dir.prototype.dirChange;
}

export class RtlModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  exports: [Dir],
  declarations: [Dir]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function RtlModule_tsickle_Closure_declarations() {
/** @type {?} */
RtlModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RtlModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
